export default "__VITE_ASSET__CfRgkKzj__"